import { render } from "./ListePaiement.vue?vue&type=template&id=c20bdd7c&ts=true"
import script from "./ListePaiement.vue?vue&type=script&lang=ts"
export * from "./ListePaiement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__